import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router'

import { ProfileResponse } from '../models/profile-response.model'
import { FundUtilityService } from '../services/fund-utility/fund-utility.service'
import { MainService } from '../services/main.service'

@Injectable({
  providedIn: 'root',
})
export class UrlResolver implements Resolve<boolean> {
  static initiallyResolved = false
  existingFundDetails: ProfileResponse
  constructor(
    private readonly mainService: MainService,
    private readonly fundUtilityService: FundUtilityService,
    private readonly router: Router,
  ) {}
  // eslint-disable-next-line max-statements
  resolve(route: ActivatedRouteSnapshot): Promise<any> {
    // eslint-disable-next-line max-statements
    return new Promise<any>((resolve) => {
      const tickerOrFundId = route.paramMap.get('tickerOrFundId')
      this.mainService.getProfileData()
      // eslint-disable-next-line max-statements

      if (this.mainService.profile$) {
        this.mainService.profile$.subscribe(
          // eslint-disable-next-line complexity
          (fundDetails) => {
            let ticker = tickerOrFundId
            if (
              !fundDetails?.fundProfile?.is529 &&
              fundDetails?.fundProfile?.ticker
            ) {
              ticker = fundDetails.fundProfile.ticker.toLowerCase()
            }
            const currentUrl = window.location.href

            if (
              this.fundUtilityService.isInvalidPrettyUrl(
                fundDetails,
                currentUrl,
              )
            ) {
              this.fundUtilityService.routeToPrettyUrl(fundDetails, currentUrl)
            } else if (tickerOrFundId !== ticker) {
              this.router.navigate(['/', ticker.toLowerCase()])
            }
            return resolve(fundDetails)
          },
          (error) => {
            resolve(error)
          },
        )
      } else {
        resolve(new Error('Not found'))
      }
    })
  }
}
